import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly sidebarDisabledSubject = new BehaviorSubject<boolean>(false);
  readonly sidebarDisabled$ = this.sidebarDisabledSubject.asObservable();

  private readonly selectedParentIdSubject = new BehaviorSubject<number | null>(null);
  readonly selectedParentId$ = this.selectedParentIdSubject.asObservable();

  private readonly menuListSubject = new BehaviorSubject<any[]>([]);
  readonly menuList$ = this.menuListSubject.asObservable();

  private readonly isSubSidebarCollapsedSubject = new BehaviorSubject<boolean>(true);
  readonly isSubSidebarCollapsed$ = this.isSubSidebarCollapsedSubject.asObservable();

  private readonly isCollapsedByUserSubject = new BehaviorSubject<boolean>(true);
  readonly isCollapsedByUser$ = this.isCollapsedByUserSubject.asObservable();

  private readonly hoveredParentIdSubject = new BehaviorSubject<number | null>(null);
  readonly hoveredParentId$ = this.hoveredParentIdSubject.asObservable();

  private readonly isHoveredModeSubject = new BehaviorSubject<boolean>(false);
  readonly isHoveredMode$ = this.isHoveredModeSubject.asObservable();

  private readonly isMobileMenuOpenSubject = new BehaviorSubject<boolean>(false);
  readonly isMobileMenuOpen$ = this.isMobileMenuOpenSubject.asObservable();

  setCollapsedByUser(value: boolean): void {
    this.isCollapsedByUserSubject.next(value);
  }

  getCollapsedByUser(): boolean {
    return this.isCollapsedByUserSubject.getValue();
  }

  setMobileMenuOpen(value: boolean): void {
    this.isMobileMenuOpenSubject.next(value);
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpenSubject.next(!this.isMobileMenuOpenSubject.getValue());
  }

  getMobileMenuOpen(): boolean {
    return this.isMobileMenuOpenSubject.getValue();
  }

  private hoverTimeout: any;

  startHoverTimeout(callback: () => void, ms = 300): void {
    this.clearHoverTimeout();
    this.hoverTimeout = setTimeout(callback, ms);
  }
  private hoverTopSubject = new BehaviorSubject<number>(0);

  hoverTop$ = this.hoverTopSubject.asObservable();

  setHoverTop(top: number): void {
    this.hoverTopSubject.next(top);
  }
  clearHoverTimeout(): void {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  setHoveredParentId(id: number | null): void {
    this.hoveredParentIdSubject.next(id);
  }

  getHoveredParentId(): number | null {
    return this.hoveredParentIdSubject.getValue();
  }

  setIsHoveredMode(value: boolean): void {
    this.isHoveredModeSubject.next(value);
  }

  getIsHoveredMode(): boolean {
    return this.isHoveredModeSubject.getValue();
  }

  setSidebarDisabled(value: boolean): void {
    this.sidebarDisabledSubject.next(value);
  }

  getSidebarDisabled(): boolean {
    return this.sidebarDisabledSubject.getValue();
  }

  setSelectedParentId(id: number | null): void {
    this.selectedParentIdSubject.next(id);
  }

  getSelectedParentId(): number | null {
    return this.selectedParentIdSubject.getValue();
  }

  setMenuList(menus: any[]): void {
    this.menuListSubject.next(menus);
  }

  getMenuList(): any[] {
    return this.menuListSubject.getValue();
  }

  setSubSidebarCollapsed(collapsed: boolean): void {
    this.isSubSidebarCollapsedSubject.next(collapsed);
  }

  getSubSidebarCollapsed(): boolean {
    return this.isSubSidebarCollapsedSubject.getValue();
  }
}

